import { Init } from "@pdfking/reactivity/preact"
import { object_map } from "@pdfking/rfunc"
import { KeyDrop, RecordMerge } from "@pdfking/tfunc"
import new_file_from_virtualfile from "../make/new_file_from_virtualfile"

export default (
  store: any,
  { computed, data, methods }: { computed?: any; data?: any; methods?: any }
) => {
  return Init({
    computed,
    data: {
      files: {},
      ...data,
    },
    methods: {
      add_files(files) {
        return Promise.all(
          files.map(async file => {
            await store.set(file.path, await file.get_file())
            this.files = RecordMerge(this.files, { [file.path]: file })
          })
        )
      },
      populate() {
        return store.startswith().then(
          files =>
            (this.files = object_map(
              (_file, path) => path,
              // @ts-expect-error TS2322
              (file, path) => new_file_from_virtualfile({ file, path }),
              files
            ))
        )
      },
      remove_files(file_ids) {
        return Promise.all(
          file_ids.map(async id => {
            await store.delete(id)
            this.files = KeyDrop(this.files, [id])
          })
        )
      },
      ...methods,
    },
    init() {
      this.populate()
    },
  })
}
